import NumerousLogo from "@/components/logo/NumerousLogo";
import { DropdownMenuTrigger } from "@/components/ui/dropdown";
import { getWhiteLabelBrand } from "./getWhiteLabelBrand";

// eslint-disable-next-line import/no-unused-modules
export const BrandedAppFloatingMenuTrigger = () => {
  const brand = getWhiteLabelBrand();

  if (brand) {
    return (
      <DropdownMenuTrigger asChild>
        <div className="flex items-center gap-2 text-sm mr-0 px-2 py-1 rounded bg-white/60 dark:bg-brand-gray-900 dark:border-brand-gray-800 border dark:hover:bg-brand-gray-800 dark:hover:border-brand-gray-700 border-brand-gray-50 hover:border-brand-primary/5 hover:bg-brand-primary/5 backdrop-blur-sm transition-all cursor-pointer">
          <span className="font-extrabold text-black dark:text-white py-1">
            <brand.Logo />
          </span>
        </div>
      </DropdownMenuTrigger>
    );
  }
  return (
    <DropdownMenuTrigger asChild>
      <div className="flex items-center gap-2 text-sm mr-0 px-2 py-1 rounded bg-white/60 dark:bg-brand-gray-900 dark:border-brand-gray-800 border dark:hover:bg-brand-gray-800 dark:hover:border-brand-gray-700 border-brand-gray-50 hover:border-brand-primary/5 hover:bg-brand-primary/5 backdrop-blur-sm transition-all cursor-pointer">
        <span className="text-[0.55rem] leading-3 text-slate-400/70">
          Powered by
        </span>
        <span className="font-extrabold text-slate-500 group-hover:text-slate-700 dark:group-hover:text-slate-300 transition-colors">
          <NumerousLogo type="brandmark" size="sm" />
        </span>
      </div>
    </DropdownMenuTrigger>
  );
};
